import { IMPROVE_CONFIG } from "@/config.js";
import axios from 'axios';

export default {
  getPartners: function(params, search, id = 0, status = '') {
    if(id != 0 && params!="") {
      return axios.get(IMPROVE_CONFIG.API_URL + "/partners" + params + search + "&id=" + id + status);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/partners" + params+ search + status);
    }
  },
  createPartner: function(partner) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/partners", {
      first_name: partner.first_name,
      last_name: partner.last_name,
      email: partner.email,
      password: partner.password,
      confirm_password: partner.confirm_password,
      company: partner.company,
      phone: partner.phone,
      address: partner.address,
      address2: partner.address2,
      city: partner.city,
      postcode: partner.postcode,
      partner_level: partner.partner_level,
      referred_by: partner.referred_by,
      //commission: partner.commission,
      groups: partner.groups,
      //referral_url: partner.referral_url,
    });
  },
  getPartnerByID: function(partnerId) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/partners/" + partnerId);
  },
  updatePartner: function(id, partner) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/partners/" + id, {
      first_name: partner.first_name,
      last_name: partner.last_name,
      email: partner.email,
      phone: partner.phone,
      address: partner.address1,
      address2: partner.address2,
      city: partner.city,
      postcode: partner.postcode,
      user_id: partner.user_id,
      referral_url: partner.referral_url
      /*partner_level: partner.partner_level,
      referred_by: partner.referred_by,
      commission: partner.commission,*/
    });
  },
  getOwners: function(params, search, id = 0,is_partner=0, state = '') {
    if(id != 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients" + params + search + "&id=" + id+"&is_partner="+is_partner + state);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients" + params + search);
    }
  },
  getOwnersDetail: function(id = 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/owner/" + id);
  },
  getPartnerByTier: function(id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/partners/tier/" + id);
  },
  getPartnersUser: function(params, search, id = 0) {
    //return axios.get(IMPROVE_CONFIG.API_URL + "/partnersuser/" +partnerId + params);
    return axios.get(IMPROVE_CONFIG.API_URL + "/partnersuser" + params + search + "&id=" + id);
  },
  getPartnerDetail: function(partnerId, params) {
    //return axios.get(IMPROVE_CONFIG.API_URL + "/partners/" + partnerId + params);
    return axios.get(IMPROVE_CONFIG.API_URL + "/partnerusers/" + partnerId + params); // comment on 24042020
    //return axios.get(IMPROVE_CONFIG.API_URL + "/partner/detail/" + partnerId);

  },
  getPartnerDetailByUserId: function(userId) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/partners/user/" + userId);
  },
  getCourses: function(params, searchParams, id = 0) {
    searchParams = (searchParams) ? searchParams : "";
    if(id != 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/courses" + params + searchParams + "&id=" + id);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/courses" + params + searchParams);
    }
  },
  getGroups: function(params, search, id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/groups" + params + search + "&id=" + id);
  },
  getChannels: function(params, id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/channels" + params + "&id=" + id);
  },
  getPartnerCustomerReports: function(id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/get-partner-customers-report", {
      id: id
    });
  },
  geCustomerReports: function(id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-customer-reports/" + id);
  },
  getManagers: function(params, search, id = 0) {
    if(id != 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients" + params + search + "&id=" + id);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients" + params + search);
    }
  },
  deleteManager: function(managerId) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/users/" + managerId);
  },
  copyNotification: function(users) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/copy-partner-notification" , {
      users: users
    });
  },
  updatePartnerState: function(id, type='') {
    return axios.post(IMPROVE_CONFIG.API_URL + "/partner/state/" + id, {
      type: type
    });
  },
  getPartnersList: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + "/partners?is_list=true");
  },
};
